const elementHelper = {
  GROUP_CHILD_ELEMENT_TYPES: ['ANSWER', 'BUTTON'],
}
export default elementHelper
